import Settings from './Settings.vue';

export default Settings;



// WEBPACK FOOTER //
// ./src/pages/profile/views/settings/index.ts